module.exports = __webpack_public_path__ + "img/serviceState5.8a63a9f1.svg";